/**
 * Any getters for easy access to things in store
 */
import dayjs from "dayjs";

export const getters = {
  questions: (state) => state.questions,
  open_questions: (state) => {
    return state.questions.filter(
      (q) =>
        q.status !== "closed" && dayjs(q.end_date).valueOf() > dayjs().valueOf()
    );
  },
  user_questions: (state) => state.my_questions,
  feed_limit: (state) => state.limit,
  getProps: (state) => state.defaultProps,
  getIcon: () => "hub",
};
